import React,{useState} from 'react';
import { navigate } from 'gatsby';
import { Form, Field } from 'react-final-form';
import axios from 'axios';

export function WebRankingReport({ page_data }) {

    return (
        <Form
            validate={values => {
                const errors = {}
                if (!values.name) {
                    errors.name = 'Required *'
                }
                if (!values.website) {
                    errors.website = 'Required *'
                }
                if (!values.email) {
                    errors.email = 'Required *'
                }
                if (!values.keywords) {
                    errors.keywords = 'Required *'
                }
                return errors
            }}
            onSubmit={handleSubmit}
            render={({ handleSubmit, form, submitting, pristine }) => (
                <form onSubmit={handleSubmit} noValidate>
                    <div className="web-ranking-form__container" id="web-ranking-form__container">
                        <div className="web-ranking-form__container--box" id="web-ranking-form">
                            <div className='form-group form-group-website'>
                                <Field name='website'>
                                    {({ input, meta }) => (
                                        <>
                                            <label htmlFor='website'>Website *</label>
                                            <input {...input} type='text'/>
                                            {meta.error && meta.touched && (
                                                <span className='form-error-message'>{meta.error}</span>
                                            )}
                                        </>
                                    )}
                                </Field>
                            </div>
                            <div className='form-group form-group-name'>
                                <Field name='name'>
                                    {({ input, meta }) => (
                                        <>
                                            <label htmlFor='name'>Name *</label>
                                            <input {...input} type='text'/>
                                            {meta.error && meta.touched && (
                                                <span className='form-error-message'>{meta.error}</span>
                                            )}
                                        </>
                                    )}
                                </Field>
                            </div>
                            <div className='form-group form-group-phone'>
                                <Field name='phone'>
                                    {({ input, meta }) => (
                                        <>
                                            <label htmlFor='phone'>Phone</label>
                                            <input {...input} type='text'/>
                                            {meta.error && meta.touched && (
                                                <span className='form-error-message'>{meta.error}</span>
                                            )}
                                        </>
                                    )}
                                </Field>
                            </div>
                            <div className='form-group form-group-email'>
                                <Field name='email'>
                                    {({ input, meta }) => (
                                        <>
                                            <label htmlFor='email'>Email *</label>
                                            <input {...input} type='text'/>
                                            {meta.error && meta.touched && (
                                                <span className='form-error-message'>{meta.error}</span>
                                            )}
                                        </>
                                    )}
                                </Field>
                            </div>
                            <div className='form-group form-group-keywords'>
                                <Field name='keywords'>
                                    {({ input, meta }) => (
                                        <>
                                            <label htmlFor='keywords'>Keywords *</label>
                                            <textarea {...input} type='textarea'/>
                                            {meta.error && meta.touched && (
                                                <span className='form-error-message'>{meta.error}</span>
                                            )}
                                        </>
                                    )}
                                </Field>
                            </div>
                            <div className='form-group form-group-learn-more'>
                                <label>Would you be interested in learning more about ActiveMedia's Search Engine Optimization service? *</label>
                                <div>
                                    <label>
                                    <Field
                                        name="learn-more"
                                        component="input"
                                        type="radio"
                                        value="Yes"
                                    />{" "}
                                    Yes
                                    </label>
                                    <label>
                                    <Field
                                        name="learn-more"
                                        component="input"
                                        type="radio"
                                        value="No"
                                    />{" "}
                                    No
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="submit-button__container">
                            <button
                                disabled={submitting}
                                className='btn submit'
                                data-text='submit'
                                type='submit'>
                                Get Your Report
                            </button>
                        </div>
                    </div>
                </form>
            )}
        />
    );
}

const handleSubmit = async values => {
    let base_data = {
        webform_id: 'web_ranking_report',
        in_draft: false
    };
    const data = {
        ...base_data,
        ...values
    };
    //console.log(data);

    const response = await axios.post(
        'https://backend.activemedia.com/react_webform_backend/submit',
        {
            ...data
        }
    );
    if (response.data.error) {
        //console.log("hahaa");
        //throw new WebformError(response);
    } else {
        navigate("/thank-you");
    }

    //console.log(response);
    //console.log('Submitted');
}

export default WebRankingReport;